import { isEmpty } from "lodash";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { actions as transferActions } from "reducers/transfers";
import InternalTransferPage from "./Internals";
import OtherTransfersPage from "./Others";

const Transfers = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const { state } = useLocation();
    const initialTab = 0;

    useEffect(() => {
        if (isEmpty(state?.beneficiary) && !state?.accountId) {
            dispatch(transferActions.setInternalTransferData({}));
            dispatch(transferActions.setOtherTransferData({}));
        }
        dispatch(transferActions.setProgramTrasferData(null));
        dispatch(transferActions.setProgramTrasferDataOther(null));
    }, [state]);

    const tabsData = [
        {
            text: "transfer.internal.title",
            textType: "I18N",
        },
        {
            text: "transfer.others.title",
            textType: "I18N",
        },
    ];
    return (
        <>
            <Notification scopeToShow="transfers" />
            <ResponsiveHeader id="transfer.others.subtitle" className="header-without-button" backLinkTo="/desktop" />
            <MainContainer>
                <CustomTabs tabsData={tabsData} tab={initialTab}>
                    <InternalTransferPage isDesktop={isDesktop} />
                    <OtherTransfersPage isDesktop={isDesktop} />
                </CustomTabs>
            </MainContainer>
        </>
    );
};

export default Transfers;

Transfers.propTypes = {
    isDesktop: bool.isRequired,
};
